import Divider from "@mui/material/Divider";
import { styled, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MuiListSubheader from "@mui/material/ListSubheader";
import Translations from "src/layouts/components/Translations";
import CanViewNavSectionTitle from "src/layouts/components/acl/CanViewNavSectionTitle";

const ListSubheader = styled((props) => <MuiListSubheader component="li" {...props} />)(
  ({ theme }) => ({
    lineHeight: 1,
    display: "flex",
    position: "static",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    backgroundColor: "transparent",
    "&:first-of-type": {
      marginTop: theme.spacing(1.5),
    },
  })
);

const TypographyHeaderText = styled(Typography)(({ theme }) => ({
  fontSize: "0.6875rem",
  lineHeight: 1.4,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
  fontWeight: 600,
}));

const VerticalNavSectionTitle = (props) => {
  const { item, navHover, settings, collapsedNavWidth, navigationBorderWidth } = props;
  const theme = useTheme();
  const { skin, navCollapsed } = settings;

  const conditionalStyling = () => {
    if (skin === "semi-dark" && theme.palette.mode === "light") {
      return {
        color: `rgba(${theme.palette.customColors.dark}, 0.55)`,
        "& .MuiDivider-root:before, & .MuiDivider-root:after, & hr": {
          borderColor: `rgba(${theme.palette.customColors.dark}, ${
            navCollapsed && !navHover ? 0.3 : 0.12
          })`,
        },
      };
    } else if (skin === "semi-dark" && theme.palette.mode === "dark") {
      return {
        color: `rgba(${theme.palette.customColors.light}, 0.55)`,
        "& .MuiDivider-root:before, & .MuiDivider-root:after, & hr": {
          borderColor: `rgba(${theme.palette.customColors.light}, ${
            navCollapsed && !navHover ? 0.3 : 0.12
          })`,
        },
      };
    } else {
      return {
        color: theme.palette.text.secondary,
        "& .MuiDivider-root:before, & .MuiDivider-root:after, & hr": {
          borderColor: `rgba(${theme.palette.customColors.main}, ${
            navCollapsed && !navHover ? 0.3 : 0.12
          })`,
        },
      };
    }
  };

  return (
    <CanViewNavSectionTitle navTitle={item}>
      <ListSubheader
        className="nav-section-title"
        sx={{
          ...conditionalStyling(),
          ...(navCollapsed && !navHover
            ? {
                py: 2,
                pr: (collapsedNavWidth - navigationBorderWidth - 24) / 8 - 1,
                pl: (collapsedNavWidth - navigationBorderWidth - 24) / 8 + 0.25,
              }
            : { px: 0.5, py: 1 }),
        }}
      >
        {navCollapsed && !navHover ? (
          <Divider sx={{ width: 22, borderColor: "divider" }} />
        ) : (
          <TypographyHeaderText noWrap component="span">
            <Translations text={item.sectionTitle} />
          </TypographyHeaderText>
        )}
      </ListSubheader>
    </CanViewNavSectionTitle>
  );
};

export default VerticalNavSectionTitle;
